import React, {useEffect} from "react";
import $ from 'jquery';
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {confirmAlert} from "../../Components/Alerts/BasicAlert";
import noImage from "../../assets/media/svg/no-image.svg";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#main-slider').DataTable({
      "bFilter": false,
      "ajax": {
        url: `${baseUrl}main-sliders`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {data: 'id', name: 'id'},
        {
          orderable: false,
          searchable: false,
          data: 'desktop_image',
          name: 'desktop_image',
          render: function (data, type, row) {
            let img = row.desktop_image || noImage;

            return `<div class="image${img == noImage ? ' no-image' : ''}">
            <img
                class="w-100${img == noImage ? ' opacity-25' : ''}"
                row-id="${row.id}" src="${img}"/>
                </div>`;
          },
        },
        {
          orderable: false,
          searchable: false,
          data: 'mobile_image',
          name: 'mobile_image',
          render: function (data, type, row) {
            let img = row.mobile_image || noImage;

            return `<div class="image${img == noImage ? ' no-image' : ''}">
            <img
                class="w-100${img == noImage ? ' opacity-25' : ''}"
                row-id="${row.id}" src="${img}"/>
                </div>`;
          },
        },
        {data: 'position', name: 'position'},
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            
                             <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        },
      ],
      order: [[3, 'asc']],
    });

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle().toggleClass("hidden-actions")
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/main-sliders/${id}/edit`);
    });

    table.on('click', 'button.delete', function () {
      const id = $(this).attr("row-id");
      confirmAlert('Do you want to delete?', () => {
        axios.delete(`/main-sliders/${id}`).then(res => {
          table.draw(false);
        });
      });
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  return (
    <div>
      <div className="d-flex flex-stack mb-5">
        <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
          <Link to='/main-sliders/create'
                className="btn btn-primary"
          >
            Add slider
          </Link>
        </div>
      </div>

      <table id="main-slider" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>ID</th>
          <th>desktop image</th>
          <th>Mobile image</th>
          <th>Position</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  );
}